import apiClient from "./axiosConfig"

const url = '/chats'

export const chatService = {
    async getSidePanelList() {
        const res = await apiClient.get(url + '/rooms/')
        return res.data
    },

    async initializeChatRoom(target_user_id) {
        const res = await apiClient.post(url + '/initialize/', { target_user_id })
        return res.data
    },

    async getMessageableUsers(currentUserRole, search = '') {
        // Recruiters search verified professionals via the dedicated search endpoint
        // Professionals see recruiter list
        if (currentUserRole === 'recruiter') {
            const params = {}
            if (search) params.name = search
            const res = await apiClient.get('/users/profile/professional/search/', { params })
            return res.data
        } else {
            const res = await apiClient.get('/users/profile/recruiter/list/')
            return res.data
        }
    },

    async getMessageHistory(roomId) {
        const res = await apiClient.get(`${url}/rooms/${roomId}/messages/`)
        return res.data
    }
}
